import { CollectionPayload, CollectionRetrieve } from '../domain/Collection'
import WallexService from './WallexService'

export default class CollectionService extends WallexService {
    public static simulate(payload: CollectionPayload): Promise<CollectionRetrieve> {
        return this.instance()
            .post('collections/simulate', payload)
            .then((response) => {
                const body = response.data as {
                    result: CollectionRetrieve
                }

                return body.result
            })
    }

    public static retrieve(collectionId: string): Promise<CollectionRetrieve> {
        return this.instance()
            .get('collections/' + collectionId)
            .then((response) => {
                const body = response.data as {
                    result: CollectionRetrieve
                }

                return body.result
            })
    }

    public static retrieveCollectionAccount(accountNumber: string): Promise<CollectionRetrieve> {
        return this.instance()
            .get('collection-account/' + accountNumber)
            .then((response) => {
                const body = response.data as {
                    result: CollectionRetrieve
                }

                return body.result
            })
    }

    public static updateCollectionAccountStatus({ accountNumber, status, provider }: { accountNumber: string; status: string; provider?: string }) {
        if (status === 'pending' || (provider === 'dbs_hk' && status === 'active'))
            return this.instance()
                .post(`/collections/${accountNumber}/simulate-ack2`)
                .then((response) => {
                    const body = response.data as {
                        result: CollectionRetrieve
                    }

                    return body
                })
        if (status === 'active')
            return this.instance()
                .post(`/collections/simulate-activate`)
                .then((response) => {
                    const body = response.data as {
                        result: CollectionRetrieve
                    }

                    return body
                })
        if (status === 'disabled')
            return this.instance()
                .post(`/collections/${accountNumber}/simulate-disabled`)
                .then((response) => {
                    const body = response.data as {
                        result: CollectionRetrieve
                    }

                    return body
                })

        return Promise.resolve({})
    }

    public static update(collectionId: string, payload: CollectionRetrieve) {
        return this.instance()
            .patch('collections/' + collectionId, payload)
            .then((response) => {
                const body = response.data as {
                    result: CollectionRetrieve
                }

                return body.result
            })
    }
}
